module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "data-vv-scope": "formNfeSettings"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit('formNfeSettings')
      }
    }
  }, [_c('description-nfe-settings'), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('span', {
    staticClass: "ls-label-text col-lg-12"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('settings.label.nfe_setting_days')) + "\n            "), _c('popover', {
    staticClass: "mb-1",
    attrs: {
      "position": 'right'
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$t('settings.tooltip.nfe_setting')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 col-sm-4 col-lg-4"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "show_setting"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.$data.nfeSettingDays),
      expression: "$parent.$data.nfeSettingDays"
    }],
    attrs: {
      "type": "number",
      "required": false,
      "min": 0,
      "max": 30,
      "name": _vm.$t('settings.main.nfe_setting_value'),
      "placeholder": _vm.$t('settings.placeholder.number')
    },
    domProps: {
      "value": (_vm.$parent.$data.nfeSettingDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.$data.nfeSettingDays = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "show_setting"
    }
  }, [_c('label', {
    staticClass: "ls-label"
  }, [_c('span', {
    staticClass: "ls-label-text col-lg-12 align-y-center "
  }, [_vm._v("\n              " + _vm._s(_vm.$t('settings.label.nfe_setting_generate')) + "\n              "), _c('authorized-link', {
    attrs: {
      "tag": "show_setting"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.$data.nfeSettingGenerate),
      expression: "$parent.$data.nfeSettingGenerate"
    }],
    staticClass: "ls-xs-margin-left",
    attrs: {
      "type": "checkbox",
      "required": false
    },
    domProps: {
      "checked": Array.isArray(_vm.$parent.$data.nfeSettingGenerate) ? _vm._i(_vm.$parent.$data.nfeSettingGenerate, null) > -1 : (_vm.$parent.$data.nfeSettingGenerate)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.$parent.$data.nfeSettingGenerate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.$parent.$data.nfeSettingGenerate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.$parent.$data.nfeSettingGenerate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$parent.$data.nfeSettingGenerate = $$c
        }
      }
    }
  })])], 1)])])], 1), _vm._v(" "), (_vm.$parent.$data.nfeSettingGenerate === true) ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "ls-label col-md-6"
  }, [_c('span', {
    staticClass: "ls-label-text"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('settings.label.municipal_registration')) + "\n            "), _c('authorized-link', {
    attrs: {
      "tag": "show_setting"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.$data.municipalRegistration),
      expression: "$parent.$data.municipalRegistration"
    }],
    attrs: {
      "type": "text",
      "required": false
    },
    domProps: {
      "value": (_vm.$parent.$data.municipalRegistration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.$data.municipalRegistration = $event.target.value
      }
    }
  })])], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.$parent.$data.nfeSettingGenerate === true) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "ls-title-5"
  }, [_vm._v(_vm._s(_vm.$t('settings.main.nfe_gateway_config_title')))]), _vm._v(" "), _vm._l((_vm.gatewayFieldsValues), function(field) {
    return _c('div', [_c('label', {
      staticClass: "ls-label"
    }, [_c('b', {
      staticClass: "ls-label-text"
    }, [_vm._v(_vm._s(field.description))]), _vm._v(" "), _c('authorized-link', {
      attrs: {
        "tag": "show_setting"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.data_value),
        expression: "field.data_value"
      }],
      attrs: {
        "type": "text",
        "name": field.tag
      },
      domProps: {
        "value": (field.data_value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          field.data_value = $event.target.value
        }
      }
    })])], 1)])
  })], 2) : _vm._e(), _vm._v(" "), _c('button-submit')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2df6a5e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/components/NfeSettings.vue
// module id = 748
// module chunks = 1